import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import { ConvoService } from '../../../service/ConvoService'
import { IConvo } from '../../../model/convo'
import convoStore from '../convo-store'
import convoUtils from './convo-utils'
import fetchReferences from './fetch-references'
import { IReference, Reference } from '../../../model/reference'

export default async function addConvoReference (context: BareActionContext<ConvoState, RootState>, convo: IConvo) {
  if (convo.meta) {
    const newUrl = convo.meta.newUrl
    const newDesc = convo.meta.newDesc
    if (newUrl || newDesc) {
        let reference: IReference = new Reference()
        reference.url = newUrl
        reference.description = newDesc
        convoUtils.convoService.addReference(convo, reference).then((result: any) => {
            convoStore.commitResetConvoReference({ convo: convo })
            fetchReferences(context, convo)
        })
    }
  }

  return
}
